module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f4aa.e5f91d0c.svg";